// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Knox from '../../../Texas/data/counties/Knox.geo.json'
import Stonewall from '../../../Texas/data/counties/Stonewall.geo.json'
import Haskell from '../../../Texas/data/counties/Haskell.geo.json'
import Throckmorton from '../../../Texas/data/counties/Throckmorton.geo.json'
import Fisher from '../../../Texas/data/counties/Fisher.geo.json'
import Jones from '../../../Texas/data/counties/Jones.geo.json'
import Shackelford from '../../../Texas/data/counties/Shackelford.geo.json'
import Stephens from '../../../Texas/data/counties/Stephens.geo.json'
import Mitchell from '../../../Texas/data/counties/Mitchell.geo.json'
import Nolan from '../../../Texas/data/counties/Nolan.geo.json'
import Taylor from '../../../Texas/data/counties/Taylor.geo.json'
import Callahan from '../../../Texas/data/counties/Callahan.geo.json'
import Eastland from '../../../Texas/data/counties/Eastland.geo.json'
import Coleman from '../../../Texas/data/counties/Coleman.geo.json'
import Brown from '../../../Texas/data/counties/Brown.geo.json'
import Comanche from '../../../Texas/data/counties/Comanche.geo.json'

const counties = {
  Knox,
  Stonewall,
  Haskell,
  Throckmorton,
  Fisher,
  Jones,
  Shackelford,
  Stephens,
  Mitchell,
  Nolan,
  Taylor,
  Callahan,
  Eastland,
  Coleman,
  Brown,
  Comanche
}

export default counties
